import React, {useState} from "react";
import useComponentVisible from "hooks/useComponentVisible";
import { ReactComponent as AngelUpIcon } from "assets/icons/angle-up.svg";
import { ReactComponent as AngelDownIcon } from "assets/icons/angle-down.svg";
import { ReactComponent as CloseIcon } from "assets/icons/close.svg";
import s from "./search-company-list.module.scss";
import { StandartButton } from "commons/form-controls";

const SearchCompanyList = (props) => {

    let {ref, isComponentVisible, setIsComponentVisible} = useComponentVisible(false);
    const [selectedItem , setSelectedItem] = useState(null);
    const [searchName, setSearchName] = useState(null);

    const setSelected = (item) => {
        setSelectedItem(item.name);
        setIsComponentVisible(false)
        props.setSelected ? props.setSelected(item) : null;
    }

    const clearSelected = () => {
        setSelectedItem(null);
        setSearchName(null);
        props.setSelected(null);
    }

    const getSelectedBlock = (k, i) => {
        return <div className={s.SearchListItem} key={i} onClick={setSelected.bind(this, k)}><span>{k.name}</span></div>
    }

    const list = searchName ? props.items.filter(k => k.name.toLowerCase().indexOf(searchName.toLowerCase()) !== -1).map((k, i) => getSelectedBlock(k, i)) : props.items ? props.items.map((k, i) => getSelectedBlock(k, i)) : null;

    let showDropdown = () =>{
        setIsComponentVisible(!isComponentVisible)
    }

    const inputChange = (event, e) => {
        let text = event.target.value;
        setSearchName(text)
        setIsComponentVisible(true)
    }

    return (
        <div className={s.SearchList} ref={ref}>
            {!selectedItem 
                ?   <div className={s.SearchListInput} onClick={showDropdown}>
                        <input value={selectedItem} onChange={inputChange.bind(this)}/>
                        { isComponentVisible ? < AngelDownIcon/> : <AngelUpIcon />}
                    </div>
                :   <div className={s.SlectedCompany}>
                        <span>{selectedItem}</span>
                        <StandartButton icon={CloseIcon} background={'white'} callback={clearSelected}/>
                    </div> 
            }
            { isComponentVisible ? <div className={s.SearchListItems}>
                {list}
            </div> : null }
        </div>
    )
}

export default SearchCompanyList;